import defaultStyles from "./default.css"

export default defaultStyles
